import { intl } from './intl';

export const { t: toastsT, Message: ToastsMessage } = intl.createMessages({
    videoUploaded: {
        ru: 'Видео загружено',
        en: 'Video uploaded',
    },
    videoDeleted: {
        ru: 'Видео удалено.',
        en: 'Video deleted.',
    },
    fileEdited: {
        ru: 'Файл успешно отредактирован.',
        en: 'File successfully edited.',
    },
    resumeUpload: {
        ru: 'Обнаружена незавершенная загрузка. Продолжаем...',
        en: 'Incomplete upload detected. Resuming...',
    },
    uploadFailed: {
        ru: 'Не удалось загрузить видео',
        en: 'Failed to upload video',
    },
    clipboardNoVideoFiles: {
        ru: 'В буфере обмена нет видеофайлов.',
        en: 'Clipboard has no video files.',
    },
    clipboardVideoFilesAdded: {
        ru: 'Добавлено видео из буфера обмена: {count}',
        en: 'Videos added from clipboard: {count}',
    },
    deleteFailed: {
        ru: 'Не удалось удалить видео.',
        en: 'Failed to delete video.',
    },
    editFailed: {
        ru: 'Не удалось отредактировать файл.',
        en: 'Failed to edit file.',
    },
    dataFetchFailed: {
        ru: 'Не удалось получить данные.',
        en: 'Failed to fetch data.',
    },
    error: {
        ru: 'Error',
        en: 'Error',
    },
    success: {
        ru: 'Success',
        en: 'Success',
    },
    info: {
        ru: 'Info',
        en: 'Info',
    },
    createVideoDocumentFailed: {
        ru: 'Не удалось создать документ для видео.',
        en: 'Failed to create video document.',
    },
    getVideoListFailed: {
        ru: 'Не удалось получить список видео.',
        en: 'Failed to get video list.',
    },
    getProfilesFailed: {
        ru: 'Не удалось загрузить профили.',
        en: 'Failed to load profiles.',
    },
    createUploadFailed: {
        ru: 'Не удалось создать загрузку',
        en: 'Failed to create upload',
    },
    updateNotificationsFailed: {
        ru: 'Не удалось изменить настройки оповещений.',
        en: 'Failed to update notification settings.',
    },
    thumbnailUploaded: {
        ru: 'Превью успешно загружено.',
        en: 'Thumbnail successfully uploaded.',
    },
    thumbnailDeleted: {
        ru: 'Превью удалено.',
        en: 'Thumbnail deleted.',
    },
    thumbnailUploadFailed: {
        ru: 'Не удалось загрузить превью.',
        en: 'Failed to upload thumbnail.',
    },
    thumbnailDeleteFailed: {
        ru: 'Не удалось удалить превью.',
        en: 'Failed to delete thumbnail.',
    },
    thumbnailInvalidFormat: {
        ru: 'Поддерживаются только форматы JPEG, PNG, GIF и WebP',
        en: 'Only JPEG, PNG, GIF and WebP formats are supported',
    },
    thumbnailTooLarge: {
        ru: 'Размер файла не должен превышать 10 МБ',
        en: 'File size must not exceed 10 MB',
    },
    downloadOriginalFailed: {
        ru: 'Не удалось получить ссылку на загрузку оригинального файла.',
        en: 'Failed to get download link for original file.',
    },
    downloadOriginalWithoutExtension: {
        ru: 'Файл загружен до 01.05.2026, расширение отсутствует. Добавьте его вручную.',
        en: 'File was uploaded before 01.05.2026, extension is missing. Add it manually.',
    },
});
